var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgRowGrave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_21350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_21350)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 24,
    r: 6,
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 14L67.7321 17H64.2679L66 14Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 34L64.2679 31L67.7321 31L66 34Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 24L73 25.7321L73 22.2679L76 24Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 24L59 22.2679L59 25.7321L56 24Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0711 31.0714L69.7251 30.1749L72.1746 27.7254L73.0711 31.0714Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9289 16.9286L62.2749 17.8251L59.8254 20.2746L58.9289 16.9286Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9286 31.0711L59.8251 27.7251L62.2746 30.1746L58.9286 31.0711Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0714 16.9289L72.1749 20.2749L69.7254 17.8254L73.0714 16.9289Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.6176 55.0918C-25.6176 55.0918 31.8941 38.5872 86.0915 71.4716C86.0915 71.4716 78.1633 112.401 10.6581 90.3929C-22.5504 79.5657 -25.6176 55.0918 -25.6176 55.0918Z",
    fill: "#FF3D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9229 52.672C20.3822 51.596 18.6035 52.135 18.6035 52.135L18.5883 52.1464C17.9596 52.3104 17.4017 52.6755 17 53.1862L17.2666 59.0899H21.3801L21.5477 53.0853L21.9229 52.672Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2022 59.0973L17.9355 53.1936C17.9355 53.1936 19.6495 50.8226 22.3938 53.0032C22.4236 53.0298 22.4516 53.0585 22.4776 53.0889L22.11 59.0973H18.2022Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4713 53.7402H20.0352V56.1074H20.4713V53.7402Z",
    fill: "#B7B7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0581 54.4644H19.4375V54.9005H21.0581V54.4644Z",
    fill: "#B7B7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9229 57.672C29.3822 56.596 27.6035 57.135 27.6035 57.135L27.5883 57.1464C26.9596 57.3104 26.4017 57.6755 26 58.1862L26.2666 64.0899H30.3801L30.5477 58.0853L30.9229 57.672Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2022 64.0973L26.9355 58.1936C26.9355 58.1936 28.6495 55.8226 31.3938 58.0032C31.4236 58.0298 31.4516 58.0585 31.4776 58.0889L31.11 64.0973H27.2022Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4713 58.7402H29.0352V61.1074H29.4713V58.7402Z",
    fill: "#B7B7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0581 59.4644H28.4375V59.9005H30.0581V59.4644Z",
    fill: "#B7B7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8553 48.6628C10.3358 47.6016 8.58149 48.1331 8.58149 48.1331L8.56646 48.1444C7.94637 48.3061 7.39623 48.6663 7 49.1699L7.26296 54.9925H11.32L11.4853 49.0704L11.8553 48.6628Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18581 55.0004L7.92285 49.1778C7.92285 49.1778 9.61328 46.8394 12.3198 48.99C12.3492 49.0163 12.3769 49.0445 12.4025 49.0745L12.04 55.0004H8.18581Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.94823 75.3809C-5.94823 75.3809 46.4345 46.4664 106.601 66.4362C106.601 66.4362 108 108.103 37.2863 101.703C2.49951 98.5544 -5.94823 75.3809 -5.94823 75.3809Z",
    fill: "#FF7D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8502 70.9342C29.7583 68.0765 25.0342 69.5079 25.0342 69.5079L24.9937 69.5382C23.3239 69.9737 21.8424 70.9436 20.7754 72.2999L21.4835 87.9796H32.4087L32.8538 72.0318L33.8502 70.9342Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9669 87.9998L23.2588 72.3201C23.2588 72.3201 27.811 66.0229 35.0995 71.8143C35.1787 71.8851 35.253 71.9611 35.322 72.0419L34.3458 87.9998H23.9669Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9962 73.772H28.8379V80.059H29.9962V73.772Z",
    fill: "#B7B7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5533 75.6943H27.249V76.8526H31.5533V75.6943Z",
    fill: "#B7B7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7604 60.404C54.6685 57.5462 49.9443 58.9776 49.9443 58.9776L49.9039 59.008C48.234 59.4434 46.7526 60.4133 45.6855 61.7696L46.3937 77.4493H57.3189L57.764 61.5015L58.7604 60.404Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8771 77.4695L48.1689 61.7898C48.1689 61.7898 52.7211 55.4926 60.0096 61.284C60.0888 61.3548 60.1632 61.4309 60.2322 61.5116L59.256 77.4695H48.8771Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6705 49.7848C80.5786 46.9271 75.8545 48.3585 75.8545 48.3585L75.814 48.3888C74.1442 48.8243 72.6627 49.7942 71.5957 51.1505L72.3038 66.8302H83.229L83.6741 50.8824L84.6705 49.7848Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7872 66.8503L74.0791 51.1707C74.0791 51.1707 78.6313 44.8735 85.9198 50.6649C85.999 50.7357 86.0733 50.8117 86.1423 50.8925L85.1661 66.8503H74.7872Z",
    fill: "#4B4A50"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRowGrave);
export default __webpack_public_path__ + "static/media/imgRowGrave.b016af0d87bf18674922fafce00c2260.svg";
export { ForwardRef as ReactComponent };